module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    class: _vm.size,
    attrs: {
      "title": "新增会员",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": function($event) {
        return _vm.submitTap('1')
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "会员昵称:",
      "prop": "user_nickname",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入昵称",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.user_nickname),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_nickname", $$v)
      },
      expression: "form.user_nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "会员卡号:",
      "prop": "card_no",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入会员卡号",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.card_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "card_no", $$v)
      },
      expression: "form.card_no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "会员姓名:",
      "prop": "real_name",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.real_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "real_name", $$v)
      },
      expression: "form.real_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "会员级别:",
      "prop": "group_id",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择级别"
    },
    model: {
      value: (_vm.form.group_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "group_id", $$v)
      },
      expression: "form.group_id"
    }
  }, _vm._l((_vm.gradeList), function(grade) {
    return _c('el-option', {
      key: grade.group_id,
      attrs: {
        "label": grade.group_name,
        "value": grade.group_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号码:",
      "prop": "mobile",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号码",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "微信号:",
      "prop": "weixin_no",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入微信号",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.weixin_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "weixin_no", $$v)
      },
      expression: "form.weixin_no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别:",
      "prop": "sex",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.sex),
      callback: function($$v) {
        _vm.$set(_vm.form, "sex", $$v)
      },
      expression: "form.sex"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日:",
      "prop": "birthday",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "请设置生日"
    },
    model: {
      value: (_vm.form.birthday),
      callback: function($$v) {
        _vm.$set(_vm.form, "birthday", $$v)
      },
      expression: "form.birthday"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址:",
      "prop": "province_id",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('region', {
    on: {
      "address": _vm.getAddress
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址:",
      "prop": "address",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入详细地址",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:",
      "prop": "remake",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.form.remake),
      callback: function($$v) {
        _vm.$set(_vm.form, "remake", $$v)
      },
      expression: "form.remake"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitTap('1')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "FF7"
    },
    on: {
      "click": function($event) {
        return _vm.submitTap('2', 'ruleForm')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54fdeb49"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/addUser.vue
// module id = 3502
// module chunks = 103